module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0LjY5NyIgaGVpZ2h0PSI3Ljk2NCIgdmlld0JveD0iMCAwIDQuNjk3IDcuOTY0Ij4KICA8cGF0aCBpZD0iQXJyb3ciIGQ9Ik0xNzU0Mi40NTUsMjg1LjM2NGwzLjYzNywzLjYyOC0zLjYzNywzLjYyOCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE3NTQyLjEwMiAtMjg1LjAxKSIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNTU1MzUzIiBzdHJva2Utd2lkdGg9IjEiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/history-arrow.svg
// module id = CbD2
// module chunks = 1